
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import HowToPlayContent from "@/components/HowToPlayContent";

const HowToPlay = () => {
  return (
    <div className="min-h-screen bg-cream px-4 py-8">
      <div className="max-w-2xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground mb-6">
          <ArrowLeft className="h-4 w-4" />
          Back to home
        </Link>

        <h1 className="font-display text-3xl mb-2 text-forest">How to Play</h1>
        <p className="text-sm text-muted-foreground mb-8">The Birdie Game</p>

        <HowToPlayContent />
      </div>
    </div>
  );
};

export default HowToPlay;
